// const API_ROOT = process.env.REACT_APP_API_ROOT || "http://127.0.0.1:8000";

// const token = localStorage.getItem("text2sql_authToken");

// export async function text2sql(query, run = true, limit = 20) {
//   const r = await fetch(`${API_ROOT}/api/text2sql`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": `Bearer ${token}`
//     },
//     body: JSON.stringify({ query, run, limit }),
//   });
//   if (!r.ok) throw new Error(`HTTP ${r.status}`);
//   return r.json();
// }
// export async function sql2text(sql, run = false, limit = 20) {
//   const r = await fetch(`${API_ROOT}/api/sql2text`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": `Bearer ${token}`
//     },
//     body: JSON.stringify({ sql, run, limit }),
//   });
//   if (!r.ok) throw new Error(`HTTP ${r.status}`);
//   return r.json();
// }


// api.js - Updated with new functions
const API_ROOT = process.env.REACT_APP_API_ROOT || "http://127.0.0.1:8000";

const token = localStorage.getItem("text2sql_authToken");

// Helper function for API calls
async function apiCall(endpoint, method = "GET", body = null) {
  const headers = {
    "Content-Type": "application/json",
    ...(token && { "Authorization": `Bearer ${token}` })
  };

  const options = {
    method,
    headers,
    ...(body && { body: JSON.stringify(body) })
  };

  const r = await fetch(`${API_ROOT}${endpoint}`, options);
  if (r.status === 401) {
    localStorage.removeItem("text2sql_authToken");
    localStorage.removeItem("text2sql_user");
    window.location.href = (process.env.REACT_APP_BASE_PATH || "") + "/login";
    return;
  }
  if (!r.ok) {
    const error = await r.json().catch(() => ({ error: `HTTP ${r.status}` }));
    throw new Error(error.message || error.error || `HTTP ${r.status}`);
  }
  return r.json();
}

// Original functions
export async function text2sql(query, run = true, limit = 20) {
  return apiCall("/api/text2sql", "POST", { query, run, limit });
}

export async function sql2text(sql, run = false, limit = 20) {
  return apiCall("/api/sql2text", "POST", { sql, run, limit });
}

// New functions for dataset management
export async function uploadDataset(formData) {
  const headers = {
    ...(token && { "Authorization": `Bearer ${token}` })
  };
  
  const r = await fetch(`${API_ROOT}/api/upload-dataset`, {
    method: "POST",
    headers,
    body: formData, // Note: No Content-Type header for FormData
  });
  
  if (!r.ok) {
    const error = await r.json().catch(() => ({ error: `HTTP ${r.status}` }));
    throw new Error(error.message || error.error || `HTTP ${r.status}`);
  }
  return r.json();
}

export async function getDatasets() {
  return apiCall("/api/datasets", "GET");
}

export async function createTableFromData(datasetId) {
  return apiCall("/api/create-table", "POST", { dataset_id: datasetId });
}

export async function executeSql(sql, datasetId = null, limit = 100) {
  return apiCall("/api/execute-sql", "POST", { 
    sql, 
    dataset_id: datasetId,
    limit 
  });
}

// Enhanced text2sql with dataset support
export async function text2sqlEnhanced(params) {
  return apiCall("/api/text2sql", "POST", params);
}

// Query history functions
export async function getQueryHistory(limit = 10) {
  return apiCall(`/api/query-history?limit=${limit}`, "GET");
}

export async function saveQuery(queryData) {
  return apiCall("/api/save-query", "POST", queryData);
}